import QuoteMark from "../QuoteMark";

export default function Quote(
    {
        text = "",
        author = ""
    }
){
    return (
        <div className="flex flex-col items-center text-center gap-[1.5rem] max-w-[645px] relative px-20 py-8">
            <div className="text-heading-4 mobile:text-heading-5 font-bold leading-[100%] text-balance max-w-[500px]">
                {text}
            </div>
            <div className="text-large">
                {author}
            </div>
            <div className="absolute top-0 left-0 w-[3.75rem]">
                <QuoteMark/>
            </div>
            <div className="absolute right-0 bottom-0 w-[3.75rem] -rotate-[180deg]">
                <QuoteMark/>
            </div>
        </div>
    )
}